import { useParams } from 'react-router'

import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import useBreakpoints from '@/hooks/useBreakpoints'
import MemberNotificationsPreferences from '../MemberNotificationsPreferences'

function MemberNotifications() {
  const { id: orgMemberIdParam } = useParams<{ id: string }>()
  const orgMemberId = orgMemberIdParam || ''

  const { isTablet, isMobile } = useBreakpoints()

  return (
    <Flex
      wfull
      gap={4}
      wrap
      className='card'
      inline={!isTablet}
      p={isMobile ? 3 : isTablet ? 5 : 7}
    >
      <Flex fraction={4} gap={2} wfull>
        <Text variant='h3'>Notifications</Text>
        <Text color='black-light-40'>
          Choose settings for notifications that are available to your members. If you do not see settings here that you expect, please consult your organization administrator.
        </Text>
      </Flex>
      <MemberNotificationsPreferences
        organizationMemberId={orgMemberId}
      />
    </Flex>
  )
}

export default MemberNotifications
